export default __webpack_public_path__ + "static/media/actionInvitation.53a785ac.svg";